import { ChatDocument } from '../../../domain/documents/models/ChatDocument';

export interface ChatDocumentsState {
    bySessionId: Record<string, ChatDocument[]>;
    isImporting: Record<string, number>; // Track number of files being imported per session
    selectedDocumentIds: Record<string, string[]>; // Track selected documents per session
}

export const initialChatDocumentsState: ChatDocumentsState = {
    bySessionId: {},
    isImporting: {},
    selectedDocumentIds: {},
};
